import apiServices from 'config/apiServiceApiGateway'
import { SupplyOrderOutboundDetailInterface } from '../@types/Outbound'

export type GetSupplyOrderListParamsType = {
  status: string
  page_index: number
  page_size?: number
  supply_order_number?: string
  supply_order_date?: number
  remarks?: string
  origin: string
  destination?: string
}

export interface GetSupplyOrderListResponseInterface {
  error: {
    status: boolean
    code: number
    message: string
  }
  pagination: {
    page_index: number
    sort: string
    page_size: number
    direction: string
  }
  data: GetSupplyOrderListResponseDataInterface[]
}
export interface GetSupplyOrderListResponseDataInterface {
  total_qty: number
  already_set_checker_packer: boolean
  id: number
  supply_order_date: string
  total_rack: number
  origin_id: number
  already_loading: boolean
  supply_order_type: string
  origin_name: string
  supply_order_loading_id: number
  picking_area: string
  supply_order_number: string
  total_item: number
  ranking: number
  picking_area_id: number
  created_at: string
  destination_id: number
  is_grouped: boolean
  created_by: string
  count_so_in_group: number
  destination_name: string
  group_parent_id?: string
  status: string
  remarks: string
  attribute: SupplyOrderAttributeInterface
}

export interface SupplyOrderAttributeInterface {
  is_xdock: boolean
}

export const getSupplyOrderList = (qsParam: string) =>
  apiServices.Get<GetSupplyOrderListResponseInterface, true>({
    url: `/wims/internal/:version/supply-orders?${qsParam}`,
    version: 'v1',
  })

export const getSupplyOrderDetailApi = (supplyOrderId: number) =>
  apiServices.Get<SupplyOrderOutboundDetailInterface>({
    url: '/wims/internal/v1/supply-orders/:supplyOrderId',
    urlParams: { supplyOrderId },
  })
